var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePwdRegular(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_211_6787)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72949 9.71875V11.8542",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45801 15.6979H2.03092C1.80439 15.6979 1.58712 15.6079 1.42694 15.4477C1.26675 15.2875 1.17676 15.0703 1.17676 14.8438V8.01042C1.17676 7.78388 1.26675 7.56662 1.42694 7.40643C1.58712 7.24624 1.80439 7.15625 2.03092 7.15625H11.4268C11.6533 7.15625 11.8706 7.24624 12.0307 7.40643C12.1909 7.56662 12.2809 7.78388 12.2809 8.01042V11.8542",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5732 7.15624V5.02083C10.5732 4.0014 10.1683 3.02373 9.44743 2.30289C8.72659 1.58204 7.74892 1.17708 6.72949 1.17708C5.71007 1.17708 4.73239 1.58204 4.01155 2.30289C3.29071 3.02373 2.88574 4.0014 2.88574 5.02083V7.15624",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44792 13.9896H19.9688C19.9688 13.9896 20.8229 13.9896 20.8229 14.8437V19.9687C20.8229 19.9687 20.8229 20.8229 19.9688 20.8229H5.44792C5.44792 20.8229 4.59375 20.8229 4.59375 19.9687V14.8437C4.59375 14.8437 4.59375 13.9896 5.44792 13.9896Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72949 16.125L9.29199 18.6875",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.29199 16.125L6.72949 18.6875",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4268 16.125L13.9893 18.6875",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9893 16.125L11.4268 18.6875",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.6H18.5",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72917 9.5052C6.7714 9.5052 6.81269 9.51773 6.8478 9.54119C6.88292 9.56466 6.91029 9.59801 6.92645 9.63703C6.94262 9.67605 6.94684 9.71898 6.93861 9.76041C6.93037 9.80183 6.91003 9.83988 6.88016 9.86974C6.8503 9.89961 6.81225 9.91994 6.77083 9.92818C6.7294 9.93642 6.68647 9.93219 6.64745 9.91603C6.60843 9.89987 6.57508 9.8725 6.55161 9.83738C6.52815 9.80227 6.51563 9.76098 6.51562 9.71875C6.51563 9.66211 6.53812 9.60779 6.57817 9.56775C6.61822 9.5277 6.67253 9.5052 6.72917 9.5052Z",
    stroke: "#64DFDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePwdRegular);
export default __webpack_public_path__ + "static/media/ChangePwdRegular.a231443dbe16f8fcd53777bcd0662b97.svg";
export { ForwardRef as ReactComponent };